import routerOptions0 from "/opt/teamcity/buildAgent/work/984757540e73c1d/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}